/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ModalRoot, { Modal, ModalBody, ModalHeader } from '../../../../components/Modal';
import { useSetting } from '../../../../utilities/sharedHooks/settings';

const SupportModal = ({ hide }) => {
  const { t: translate } = useTranslation();
  const [cardSupportEmailAddress] = useSetting(
    'server_configurations',
    'card_support_email_address'
  );
  return (
    <ModalRoot>
      <Modal
        contentStyle={{
          maxHeight: '15rem',
        }}>
        <ModalHeader>
          <i
            onClick={hide}
            onKeyDown={hide}
            role="button"
            className="close-btn cursor-pointer icon icon-close-other text-shadow"
            tabIndex={-1}
            aria-label="Close"
          />
        </ModalHeader>
        <ModalBody>
          <div className="text-f5 text-bold p-0">
            {translate('card_order_confirm_name_having_trouble')}
          </div>
          <div className="text-f5 mt-2 p-0">{translate('card_order_confirm_trouble_label')}</div>
          <a
            href={`mailto:${cardSupportEmailAddress}`}
            className="text-f5 text-primary p-0 text-decoration-none">
            {cardSupportEmailAddress}
          </a>
        </ModalBody>
      </Modal>
    </ModalRoot>
  );
};

SupportModal.propTypes = {
  hide: PropTypes.func,
};

export default SupportModal;
